// extracted by mini-css-extract-plugin
export var actionButton = "_oz-0";
export var actionMenuContainer = "_oz-i";
export var bubble = "_oz-2";
export var bubbleActionMenu = "_oz-j";
export var bubbleContext = "_oz-6";
export var bubbleItems = "_oz-7";
export var customer = "_oz-3";
export var divider = "_oz-8";
export var fileList = "_oz-9";
export var hiddenComment = "_oz-o";
export var infoAbove = "_oz-a";
export var internal = "_oz-4";
export var lightActionButton = "_oz-1";
export var link = "_oz-b";
export var merchant = "_oz-5";
export var message = "_oz-c";
export var profilePicture = "_oz-e";
export var quillToolbarContainer = "_oz-f";
export var senderDate = "_oz-g";
export var senderDateCustomer = "_oz-h";
export var senderName = "_oz-d";
export var time = "_oz-k";
export var uploadedImage = "_oz-l";
export var username = "_oz-m";
export var xsmall = "_oz-n";